import type { SpaceMode } from "../../shared/schema";

export type ConnectPromptState = "options" | "resolveEmpty" | "unavailable";

export function creatableConnectorIdentifiers(
  canCreateApp: boolean,
  matchingIdentifiers: string[]
): string[] {
  return canCreateApp ? matchingIdentifiers : [];
}

// Creating a connector in a shared space grants the space's members access,
// which requires tenant:connected_app_share. Without it, creation is only
// offered where creator-only grants suffice: personal chats (no space in
// context) and personal spaces. An unloaded space reads as non-personal so we
// never offer a creation that the mutation would reject.
export function canCreateConnectorInChat({
  canCreateApp,
  canShare,
  spaceId,
  spaceMode,
}: {
  canCreateApp: boolean;
  canShare: boolean;
  spaceId: string | undefined;
  spaceMode: SpaceMode | undefined;
}): boolean {
  if (!canCreateApp) return false;
  if (canShare) return true;
  if (!spaceId) return true;
  return spaceMode === "personal";
}

// `singleViewerPath` is true for personal chats and CLI claims, where an empty
// prompt auto-resolves the tool. On the shared workflow path it's false:
// resolving there would close the prompt for every collaborator, so a viewer
// who can't act sees an informational state instead.
export function connectPromptState({
  itemCount,
  singleViewerPath,
}: {
  itemCount: number;
  singleViewerPath: boolean;
}): ConnectPromptState {
  if (itemCount > 0) return "options";
  return singleViewerPath ? "resolveEmpty" : "unavailable";
}

export function otherCollaboratorsPresent({
  personal,
  currentUserId,
  presentUserIds,
}: {
  personal: boolean;
  currentUserId: string;
  presentUserIds: Iterable<string>;
}): boolean {
  if (personal) return false;
  for (const id of presentUserIds) {
    if (id !== currentUserId) return true;
  }
  return false;
}
